// Libs
import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Box, FormHelperText, InputLabel, Stack } from '@mui/material';
// Components, Layouts, Pages
// Others
import { DEFAULT_NUMBER_ZERO } from '~/utils/constants/common';
// Styles, images, icons
import styles from './BaseColorSelect.module.scss';

type Props = {
  name?: string;
  label?: string;
  value?: string;
  colors?: string[];
  required?: boolean;
  errorMessage?: string;
  size?: number;
  onChange?: (color: string) => void;
};

const cx = classNames.bind(styles);

const BaseColorSelect = (props: Props) => {
  //#region Destructuring Props
  const { name, label, value, colors, required = false, errorMessage, size, onChange } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [colorSelected, setColorSelected] = useState<string>();
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (!value) {
      setColorSelected(colors?.[DEFAULT_NUMBER_ZERO]);
    }

    setColorSelected(value);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleItemSelected = (color: string) => {
    setColorSelected(color);

    if (onChange) {
      onChange(color);
    }
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='baseColorSelectComponent' className={cx('baseColorSelectContainer')}>
      {label && (
        <InputLabel required={required} className={cx('label')}>
          {label}
        </InputLabel>
      )}

      <Stack
        className={cx('colorList')}
        style={{ minHeight: size }}
        direction={'row'}
        alignItems={'center'}
        gap={2}
        flexWrap={'wrap'}
      >
        {Array.isArray(colors) &&
          colors?.map((color, index) => (
            <Box
              id={name}
              key={index}
              component={'div'}
              className={cx('colorItem', { active: colorSelected === color })}
              sx={{ bgcolor: color, borderColor: color }}
              onClick={() => handleItemSelected(color)}
            ></Box>
          ))}
      </Stack>

      {errorMessage && <FormHelperText className={cx('errorMessage')}>{errorMessage}</FormHelperText>}
    </Box>
  );
};

export default BaseColorSelect;
